import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutTemplate} from '../../domain/workout-template';
import type {
  ReplaceTemplateExercisesInput,
  WorkoutRepository,
} from '../ports/workout.repository';

export class ReplaceWorkoutTemplateExercises
  implements UseCase<[ReplaceTemplateExercisesInput], WorkoutTemplate>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(
    input: ReplaceTemplateExercisesInput,
  ): Promise<Result<WorkoutTemplate, WorkoutError>> {
    return this.repository.replaceTemplateExercises(input);
  }
}
